module.exports = __webpack_public_path__ + "static/img/index_service_1.bd04934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SHscreen/index_service_1.png
// module id = Uwk5
// module chunks = 4